import { Exchange } from 'modules/Search/constants';

export const DEFAULT_OPTION_CHAIN_TABLE_SETTINGS: OCTableSettings = {
  columnSettings: {
    columns: {
      showOIChange: true,
      showVolume: true,
      showIV: true,
      showAsk: false,
      showBid: false,
    },
    greeks: {
      showDelta: true,
      showTheta: true,
      showGamma: true,
      showVega: true,
    },
  },
  dataSettings: {
    noOfStrikes: 'show10',
    changeIn: 'changePer',
  },
};

export const SETTINGS_MENU_CHECKBOX_OPTIONS: ColumnSettingsMenuOptions[] = [
  {
    type: 'columns',
    label: 'Add columns',
    options: [
      {
        label: 'Volume',
        type: 'showVolume' as ColSettingsOptionType,
      },
      {
        label: 'OI Change',
        type: 'showOIChange' as ColSettingsOptionType,
      },
      {
        label: 'IV',
        type: 'showIV' as ColSettingsOptionType,
      },
      {
        label: 'Bid price',
        type: 'showBid' as ColSettingsOptionType,
      },
      {
        label: 'Ask price',
        type: 'showAsk' as ColSettingsOptionType,
      },
    ],
  },
  {
    type: 'greeks',
    label: 'Add greeks',
    options: [
      {
        label: 'Delta',
        type: 'showDelta' as ColSettingsOptionType,
      },
      {
        label: 'Theta',
        type: 'showTheta' as ColSettingsOptionType,
      },
      {
        label: 'Gamma',
        type: 'showGamma' as ColSettingsOptionType,
      },
      {
        label: 'Vega',
        type: 'showVega' as ColSettingsOptionType,
      },
    ],
  },
];

export const SETTINGS_MENU_RADIO_OPTIONS: DataSettingsMenuOptions[] = [
  {
    type: 'noOfStrikes',
    label: 'No. of strikes',
    options: [
      {
        label: 'Show 10',
        value: 'show10',
      },
      {
        label: 'Show All',
        value: 'showAll',
      },
    ],
  },
  {
    type: 'changeIn',
    label: 'Show change in',
    options: [
      {
        label: 'Change %',
        value: 'changePer',
      },
      {
        label: 'Change value',
        value: 'changeVal',
      },
    ],
  },
];

export enum SETTINGS_COMPONENT {
  radio = 'radio',
  checkbox = 'checkbox',
}

export enum DATA_SETTINGS {
  showAll = 'showAll',
  show10 = 'show10',
  changePer = 'changePer',
  changeVal = 'changeVal',
}

export const spotRowDummyData = {
  strike: Number.MAX_SAFE_INTEGER,
  exchangeTokens: { CE: '1', PE: '2' },
  instrumentKeys: { CE: '1', PE: '2' },
  rowType: 'spot',
};

export const OFFSET_ROWS_BEFORE_SPOT = 6;

export const OI_ANALYSIS_INDICES: Record<string, Exchange> = {
  NIFTY: Exchange.NSE,
  BANKNIFTY: Exchange.NSE,
  FINNIFTY: Exchange.NSE,
  SENSEX: Exchange.BSE,
  MIDCPNIFTY: Exchange.NSE,
};
